<template>
  <div class="flex h-full flex-col px-0">
    <NavBar v-if="!isWebView" />
    <div class="flex flex-1 overflow-y-auto">
      <main class="flex-1">
        <slot />
      </main>
    </div>
    <ToastContainer />
  </div>
</template>
x
<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'

import NavBar from '@/components/layout/NavBar.vue'
import ToastContainer from '@/components/ui/ToastContainer.vue'

const store = useStore()
const isWebView = computed(() => store.getters['users/isWebView'])
</script>
